/* eslint-disable no-unused-vars */
import AuthService from "../services/auth.service.js";
import { hasAccessToken } from "../services/token.service";
import { isPublicAuthLocation } from "../utils/public-auth-routes";
import { clearSsoHandoff } from "../utils/sso-entry";

// Do not treat stale tokens as logged-in on public auth pages (e.g. password reset).
const isAuthenticated = isPublicAuthLocation() ? false : hasAccessToken();
export const auth = {
  namespaced: true,
  state: { isAuthenticated: isAuthenticated },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
  },
  actions: {
    async login({ commit }, user) {
      await AuthService.login(user);
      commit('isAuthenticated', true);
    },
    async logout({ commit }) {
      try {
        clearSsoHandoff();
        await AuthService.logout();
      } finally {
        commit('isAuthenticated', false);
      }

    },
    async register({ commit }, user) {
      await AuthService.register(user);
      commit('isAuthenticated', true);
    },
    async forgotPassword({ commit }, data) {
      await AuthService.forgotPassword(data);
    },
    async validateResetPasswordToken({ commit }, data) {
      return await AuthService.validateResetPasswordToken(data);
    },
    async resetPassword({ commit }, data) {
      await AuthService.resetPassword(data);
    }
  },
  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload;
    },
  }
};
